export const enum InputType {
  Text = 'text',
  Password = 'password',
  Email = 'email',
  Hidden = 'hidden',
}
